import styled from 'styled-components'
import {colors, typography} from '../styles'

export default styled.a`
  color: ${colors.blueText};
  ${typography.noDecoration}
  &:hover,&:active {
    box-shadow: inset 0 -1px;
  }
`



/** WEBPACK FOOTER **
 ** ./src/components/A.js
 **/